module.exports = __webpack_public_path__ + "images/no-results-icon.png?h=66451a4d6b436764ffb6c3f57a4290db";


//////////////////
// WEBPACK FOOTER
// ./src/components/public/cart/ItemsList/images/no-results-icon.png
// module id = 2871
// module chunks = 49